import { HttpClient, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UploadFile } from 'ng-zorro-antd';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FileUploadService {

  constructor(private http: HttpClient) { }

  get(attachmentType: string): Observable<UploadFile[]> {
    return this.http.get<UploadFile[]>(`files/${attachmentType}`);
  }

  delete(attachmentType: string, id: string): Observable<any> {
    return this.http.delete<any>(`files/${attachmentType}/${id}`);
  }


  post(req: HttpRequest<any>): Observable<any> {
    return this.http.request(req);
  }

  saveAll(files: any[]) {
    sessionStorage.setItem('attachments', JSON.stringify(files));
  }

  clear(){
    sessionStorage.removeItem('attachments');
  }

  getAll() {
    return JSON.parse(sessionStorage.getItem('attachments'));
  }

  saveOne(newFile: any) {
    let files = this.getAll();
    files.push(newFile);
    this.saveAll(files);
  }

  remove(attachmentType: string, fileId: any) {
    let files = this.getAll()
    files = files.filter(file => {
      if (file.tipDoc == attachmentType) {
        if ((file.id || file.response) == fileId) {
            return false;
        }
      }
      return true;
    });
    this.saveAll(files)
  }

  getAllTypes() {
    return ['endereco', 'basico', 'dependente', 'financeiro', 'inscricao_municipal', 'observacoes', 'profissional'];
  }

  deleteInss(query): Observable<any> {
    return this.http.delete<any>(`files/inss/${query}`);
  }
}
